import Axios from 'axios';
import jwtDecode from 'jwt-decode';
import { addProjectScopeToRoute } from './addProjectScopeToRoute';

const axios = Axios.create();
axios.interceptors.response.use((response) => response, handleResponseError);
axios.interceptors.request.use((response) => response, handleRequestError);

function handleResponseError(error) {
  return Promise.reject(error);
}
function handleRequestError(error) {
  return Promise.reject(error);
}

/**
 *
 * @param {string} route
 * @param {string} method
 * @param {object} body
 * @param {object} config
 * @param {string} cstm
 */
export async function sendProjectRequest(
  route,
  method = 'get',
  body,
  config = {},
  cstm
) {
  let reqRoute = route;
  const reqMethod = method.toLowerCase();
  const tokenName =
    route.indexOf('recruiter') !== -1 ? 'recruiterToken' : 'token';
  let headers = {
    Authorization: `Bearer ${localStorage.getItem(tokenName)}`,
  };
  if (config.headers) {
    headers = { ...headers, ...config.headers };
    delete config.headers; // eslint-disable-line
  }
  const requestConfig = { headers, ...config };
  let response;
  if (cstm) {
    reqRoute = addProjectScopeToRoute(reqRoute, cstm);
  }
  switch (reqMethod) {
    case 'get':
      response = await axios[reqMethod](reqRoute, requestConfig);
      break;
    case 'delete':
      requestConfig.data = body; // axios hat eine verwirrende syntax, vgl unten post-Request
      response = await axios[reqMethod](reqRoute, requestConfig);
      break;
    default:
      // Code getestet für post
      response = await axios[reqMethod](reqRoute, body, requestConfig);
      break;
  }
  return response && response.data;
}
/**
 *
 * @param {boolean} recr kommt die Request aus dem Rec-Context
 */
export async function checkAndRefreshToken(recr) {
  const tokenName = recr ? 'recruiterToken' : 'token';
  const token = localStorage.getItem(tokenName); // TODO: Fehlerbehandlung, falls kein Token vorhanden
  if (!token) return false;
  const decodedToken = jwtDecode(token);
  const expirationDate = decodedToken.exp;

  const isTokenExpired = expirationDate
    ? expirationDate - Date.now() / 1000 < 0
    : true;
  if (isTokenExpired) {
    try {
      const refreshResponse = await axios.post(
        '/api/refreshToken',
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const newToken = refreshResponse.data.access_token;
      if (newToken) {
        localStorage.setItem(tokenName, newToken);
        return true;
      }
    } catch (e) {
      return false;
    }
  }
  return true;
}
